module.exports = __webpack_public_path__ + "img/vue.af0869d3.png";